const print_config = {
  css_stylesheet: `
  :root {
    --print-border-solid: 1px solid rgba(0, 0, 0, 0.2);
    --print-shadow: 0 2px 10px 0 rgba(33, 35, 68, 0.05) !important;
    --print-chart-bg: #fcfcfc;
    --print-table-bg: #f9f9fa;
    --print-white: #fff;
    --print-primary-color: #171e48;
    --print-danger-color: #fa5959;
  }

  html {
    background-color: var(--print-white);
  }

  html * {
    float: none !important;
  }

  body {
    font-family: 'Roboto', sans-serif;
    margin: 0;
  }
  .date-text {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
}
  .dashboard-container {
    display: block !important;
    padding-left: 8px;
    padding-right: 8px;
    background-color: var(--print-white);
    padding: 60px;
    padding-bottom: 0;
  }

  .dashboard-row {
    margin-bottom: 24px;
    break-inside: avoid;
    width: 100%;
  }

  .dashboard-row--half-w {
    display: inline-block;
    width: 50%;
    vertical-align: top;
  }

  .dashboard-row--page-break {
    break-inside: unset;
  }

  .dashboard-row__name {
    margin: 0 0 10px;
    padding-bottom: 8px;
    font-weight: 400;
    font-size: 16px;
    font-weight: 500;
    break-before: avoid;
  }

  .dashboard-row__chart {
    padding: 16px;
    background-color: var(--print-chart-bg);
  }

  .dashboard-row__chart--no-bg {
    background-color: transparent;
    padding: 0;
  }

  .dashboard-row__chart--number {
    box-sizing: border-box;
    height: 124px;
    min-height: 124px;
    width: 360px;
  }

  .dashboard-row__chart--progress-card {
    box-sizing: border-box;
    height: 145px;
    min-height: 145px;
    width: 360px;
  }

  .transmittal-widget__name {
    font-size: 12px;
    text-transform:Uppercase;
    color: var(--print-primary-color);
  }

  .transmittal-widget__value {
    font-size: 16px;
    font-weight: 500;
    color: var(--print-primary-color);
  }

  .transmittal-table__th{
     text-transform: uppercase;
     background-color: rgb(249, 250, 251);
  }

  .terra-map {
    height: 420px;
    width: 100%;
    margin: 20px 0 40px;
    background-color: #fff;
  }

  .terra-map img {
    object-fit: contain;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  }

  .terra-map__timestamp {
    font-size: 14px;
  }

  .terra-map__icon {
    width: 12px;
    height: 12px;
    border-radius: 100%;
    border: 2px solid;
    margin-left: 2px;
  }

  .fusion-chart {
    width: auto;
    height: 320px;
    width: 720px;
    margin: 0 auto;
  }

  .fusion-chart--gauge {
    width: 480px;
  }

  .fusion-chart__legend {
    margin-top: 24px;
    font-weight: 500;
    opacity: .7;
    font-size: 14px;
  }
.dashboard-header {
  box-sizing: border-box;
  border-bottom: var(--print-border-solid);
  border-width: 2px;
  margin-bottom: 40px;
}
  .dashboard-intro {
    display: flex;
    justify-content: space-between;
  }

  .dashboard-intro__logo {
    display: flex;
    align-items: center;
  }

  .dashboard-intro__logo>img {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .dashboard-intro__content h3 {
    font-size: 24px;
    font-weight: 500;
    margin: 0 0 16px;
    opacity: 0.75;
  }

  .dashboard-intro__content {
    text-align: right;
    max-width: 400px;
  }

  .dashboard-intro__meta {
    font-size: 16px;
  }

  .dashboard-intro__meta>span {
    font-weight: 500;
  }

  /* TABLE */
  table {
    text-align: left;
    background-color: var(--print-white);
    border-spacing: 0;
    border: var(--print-border-solid);
    border-bottom: none;
    position: relative;
    break-inside: auto;
    margin-bottom: 20px;
    border-right: 0;
  }

  .table--fill-width {
    width: 100%;
    table-layout: fixed;
  }
  .table--fill-width th:not(.first-cell--big),
  .table--fill-width td:not(.first-cell--big) {
    max-width: fit-content;
    width: auto;
    min-width: auto;
  }

  table tbody tr,
  table thead tr {
    break-inside: avoid;
    break-after: auto;
  }

  table thead {
    break-inside: avoid;
    display: table-header-group;
  }

  table thead th {
    font-weight: 500;
  }

  table th,
  table td {
    padding: 8px;
    vertical-align: top;
    border-bottom: var(--print-border-solid);
    max-width: 95px;
    width: 95px;
    vertical-align: middle;
    break-inside: avoid;
    font-size: 12px;
    backface-visibility: hidden;
    overflow: hidden;
    text-align: left;
  }

  table thead tr > *,
  table tbody tr > *,
  table tfoot tr > * {
    border-right: var(--print-border-solid);
  }

  .first-cell {
    max-width: 150px;
    width: 150px;
    min-width: 150px;
  }

  .first-cell--big {
    max-width: 250px;
    width: 250px;
    min-width: 250px;
  }

  .table--list .first-cell {
    max-width: 400px;
    width: 400px;
    min-width: 400px;
  }

  .table--list table th,
  .table--list table td {
    max-width: 120px;
    width: 120px;
  }

  .table-terra__color {
    width: 20px;
    max-width: 20px;
    min-width: 20px;
  }

  .table-terra__name {
    width: 420px;
    max-width: 420px;
    min-width: 420px;
  }

  .table-terra__value {
    width: 120px;
    max-width: 120px;
    min-width: 120px;
  }

  .table-single-form__no-data {
    width: 745px;
    max-width: 745px;
    min-width: 745px;
  }

  .table-single-form__index {
    width: 20px;
    max-width: 20px;
    min-width: 20px;
  }

  .table-single-form__name {
    width: 180px;
    max-width: 180px;
    min-width: 180px;
  }

  .table-single-form__value {
    width: 544px;
    max-width: 546px;
    min-width: 546px;
  }

  .table-single-form__table-header {
    padding: 8px;
    vertical-align: top;
    border: var(--print-border-solid);
    border-bottom: none;
    max-width: calc(100% - 16px);
    width: calc(100% - 16px);
    background: #F9F9FA
    vertical-align: middle;
    break-inside: avoid;
    font-size: 12px;
    backface-visibility: hidden;
    overflow: hidden;
    text-align: left;
    font-weight: 500;
  }

  .single-form-step-meta {
    width: 260px;
    margin-top: 16px;
    font-size: 12px;
    font-weight: 500;
  }

  .single-form-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  .single-form-status {
    position: relative;
    height: 22px;
    width: min-content;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 500;
    padding: 0 6px;
    margin-right: 16px;
  }

  .single-form-status__background {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    border-radius: 10px;
    opacity: 0.25;
  }

  .single-form-signature {
    display: block;
    max-width: 100%;
    max-height: 300px;
    margin-bottom: 8px;
  }

  table thead {
    background-color: var(--print-table-bg);
  }

  /* LIST */

  .table-list-more {
    margin-top: 16px;
    font-weight: 500;
    opacity: .7;
    font-size: 14px;
  }

  /* END LIST */

  /* Index widget */

  .index-widget__name {
    font-size: 14px;
    color: var(--print-primary-color);
    margin-bottom: 10px;
  }

  .index-widget__value {
    font-size: 18px;
    font-weight: 700;
    color: var(--print-primary-color);
  }

  .index-widget__value--danger {
    color: var(--print-danger-color);
  }

  /* End Index widget */

  /* Number chart widget */

  .number-chart__value {
    font-size: 20px;
  }

  .number-chart__trend {
    display: flex;
    align-items: flex-end;
    font-size: 12px;
    padding: 4px;
    border-radius: 4px;
    font-weight: 500;
    margin-left: 8px;
    background-color: #ECFDF3;
    color: #027A48;
  }

  .number-chart__trend--danger {
    background-color: #FEF3F2;
    color: #B42318;
  }

  .number-chart__trend > :last-child {
    margin-left: 4px;
  }

  .number-chart__trend-description {
    font-size: 14px;
    margin-top: 8px;
  }

  .number-chart__icon {
    width: 16px;
    height: 16px;
    margin-right: 3px;
  }

  .number-chart__icon--rotate {
    transform: scale(1, -1);
  }

  /* Pivot Table Header styles */

  .pivot-table .rowHeaderCell {
    background-color: rgb(249, 250, 251);
  }

  .pivot-table .columnHeaderCell {
    background-color: rgb(247, 247, 247);
  }
  `,
  // DON'T MODIFY THIS - START
  prose_mirror_editor_styling: `
  .ProseMirror blockquote {
    padding-left: 1em;
    border-left: 3px solid #eee;
    margin-left: 0;
    margin-right: 0;
  }

  .ProseMirror figure {
    float: none !important;
    max-width: 100%;
  }

  .ProseMirror figure img {
    width: 100%;
    max-width: 100%;
  }

  .ProseMirror-table-menu {
    cursor: pointer;
    position: relative;
  }
  
  .ProseMirror-table-menu #context_menu {
    position: absolute;
    width: 200px;
    line-height: normal;
  }
  
  .ProseMirror-table-menu #context_menu .table-context-option {
    color: #171e48;
  }
  
  .ProseMirror-table-menu #context_menu .table-context-option:nth-child(1) svg,
  .ProseMirror-table-menu #context_menu .table-context-option:nth-child(2) svg {
    fill: none;
  }
  
  .ProseMirror-table-menu #context_menu .table-context-option svg {
    opacity: 1 !important;
  }
  
  #context_menu,
  .ProseMirror-table-menu #context_menu {
    background: white;
    position: fixed;
    z-index: 100;
    border-radius: 2px;
    display: none;
    cursor: pointer;
    box-shadow: 0px 1px 2.5px rgba(23, 26, 27, 0.15), 0px 0px 2px rgba(23, 26, 27, 0.15);
    padding: 5px 0px;
  }
  
  #context_menu ul li,
  .ProseMirror-table-menu #context_menu ul li {
    padding: 6px 10px;
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 14px;
  }
  
  #context_menu ul li span,
  .ProseMirror-table-menu #context_menu ul li span {
    margin-left: 5px;
  }
  
  #context_menu ul li i,
  .ProseMirror-table-menu #context_menu ul li i {
    color: #595959;
  }
  
  #context_menu ul li:hover,
  .ProseMirror-table-menu #context_menu ul li:hover {
    background: #e1e2e7;
  }
  
  #context_menu.visible,
  .ProseMirror-table-menu #context_menu.visible {
    display: block !important;
  }
  
  #context_menu .table-context-option,
  .ProseMirror-table-menu #context_menu .table-context-option {
    position: relative;
  }
  
  #context_menu .table-context-option .table-color-options,
  .ProseMirror-table-menu #context_menu .table-context-option .table-color-options {
    display: none;
    flex-wrap: wrap;
    flex-direction: row;
    width: 92px;
    position: absolute;
    right: -92px;
    gap: 5px;
    background: white;
    top: 0;
    border: 1px solid #ccc;
    padding: 8px 10px;
  }
  
  #context_menu .table-context-option .table-color-options .table-color-options-box,
  .ProseMirror-table-menu #context_menu .table-context-option .table-color-options .table-color-options-box {
    width: 20px;
    height: 20px;
  }
  
  #context_menu .table-context-option:hover .table-color-options,
  .ProseMirror-table-menu #context_menu .table-context-option:hover .table-color-options {
    display: flex;
  }
  
  .prosemirror-editor .ProseMirror {
    font-size: 14px;
    font-family: "Roboto-Regular", sans-serif;
  }
  
  .prosemirror-editor .ProseMirror h1,
  .prosemirror-editor .ProseMirror h2,
  .prosemirror-editor .ProseMirror h3,
  .prosemirror-editor .ProseMirror h4,
  .prosemirror-editor .ProseMirror h5,
  .prosemirror-editor .ProseMirror h6 {
    font-size: revert;
    font-weight: normal;
  }
  
  .prosemirror-editor .ProseMirror ul,
  .prosemirror-editor .ProseMirror ol {
    padding-left: 15px;
  }
  
  .prosemirror-editor .ProseMirror ul {
    list-style: revert !important;
  }
  
  .prosemirror-editor .ProseMirror ul li {
    list-style: inherit;
  }
  
  .prosemirror-editor .ProseMirror p {
    margin-bottom: 11px;
  }
  
  .prosemirror-editor .ProseMirror p * {
    /* line-height: 26px; */
  }

  .prosemirror-editor .ProseMirror p img {
    max-width: 100%;
  }
  
  .prosemirror-editor .ProseMirror p a {
    color: #3979f7 !important;
    text-decoration: revert !important;
  }
  
  .prosemirror-editor .ProseMirror-menubar-wrapper .prosemirror-highlight-container {
    display: flex;
    gap: 4px;
    background: #fff;
    flex-direction: row;
    flex-wrap: wrap;
    width: 90px;
    padding: 5px 10px;
    border: 1px solid #eaeaea;
    border-radius: 2px;
  }
  
  .prosemirror-editor .ProseMirror-menubar-wrapper .prosemirror-highlight-container .prosemirror-highlight-box {
    border-radius: 2px;
    cursor: pointer;
    width: 20px;
    height: 20px;
  }
  
  .prosemirror-editor .ProseMirror-menubar {
    display: flex;
    flex-wrap: wrap;
    min-height: unset !important;
    align-items: center;
    padding: 5px 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  
  .prosemirror-editor .ProseMirror-menubar .ProseMirror-menuitem {
    margin-right: 0;
  }
  
  .prosemirror-editor .ProseMirror-menubar .ProseMirror-menuitem>* {
    margin: 3px 5px;
  }
  
  .prosemirror-editor .ProseMirror-menubar .ProseMirror-menuitem .ProseMirror-icon svg {
    fill: #171e48;
    opacity: 0.8;
  }
  
  .prosemirror-editor .ProseMirror-menubar .ProseMirror-menuitem:hover {
    background-color: #e1e1e1;
  }
  
  .prosemirror-editor .ProseMirror-menubar .ProseMirror-menuitem .ProseMirror-menu-dropdown-wrap .ProseMirror-menu-dropdown-menu,
  .prosemirror-editor .ProseMirror-menubar .ProseMirror-menuitem .ProseMirror-menu-dropdown-wrap .ProseMirror-menu-submenu {
    color: #171e48;
    background: #fff;
    opacity: 1;
    border: 1px solid #eaeaea;
  }
  
  .prosemirror-editor .ProseMirror-menubar .ProseMirror-menuitem .ProseMirror-menu-dropdown-menu.ProseMirror-table-menu {
    opacity: 1 !important;
    border: 1px solid #eaeaea;
    border-radius: 2px;
  }
  
  .prosemirror-editor .ProseMirror-menubar .ProseMirror-menuitem .ProseMirror-menu-dropdown-menu.ProseMirror-table-menu .ProseMirror-menu-dropdown-item {
    font-size: 14px;
    padding: 6px 10px;
  }
  
  .prosemirror-editor .ProseMirror-menubar .ProseMirror-menuitem .ProseMirror-menu-dropdown-menu.ProseMirror-table-menu .ProseMirror-menu-dropdown-item:hover {
    background: #e1e2e7;
  }
  
  .prosemirror-editor .ProseMirror-menubar .ProseMirror-menuitem .ProseMirror-highlight-menu {
    position: relative;
  }
  
  .prosemirror-editor .ProseMirror-menubar .ProseMirror-menuitem .ProseMirror-highlight-menu .prosemirror-highlight-container {
    position: absolute;
  }
  
  .prosemirror-editor .ProseMirror-menubar .ProseMirror-menuitem:nth-child(5) {
    display: none;
  }
  
  .prosemirror-editor .prosemirror-image-popup,
  .prosemirror-editor .prosemirror-anchor-popup {
    position: absolute;
    z-index: 20;
    background: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    margin-bottom: 7px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    padding: 5px;
    display: flex;
    gap: 5px;
    font-size: 12px;
  }
  
  .prosemirror-editor .prosemirror-image-popup input[type="url"],
  .prosemirror-editor .prosemirror-anchor-popup input[type="url"] {
    padding: 5px 10px;
    border: 1px solid #eaeaea;
  }
  
  .prosemirror-editor .prosemirror-image-popup input[type="url"]:focus,
  .prosemirror-editor .prosemirror-anchor-popup input[type="url"]:focus,
  .prosemirror-editor .prosemirror-image-popup input[type="url"]:hover,
  .prosemirror-editor .prosemirror-anchor-popup input[type="url"]:hover {
    outline: 0;
    background: transparent;
  }
  
  .prosemirror-editor .prosemirror-image-popup button,
  .prosemirror-editor .prosemirror-anchor-popup button {
    padding: 0 10px;
    background-color: #eaeaea;
    color: #171e48;
    border: none;
    border-radius: 2px;
    cursor: pointer;
    font-family: Roboto-Regular, sans-serif;
    font-size: 12px;
  }
  
  .prosemirror-editor .prosemirror-image-popup::before {
    display: none;
  }
  
  .prosemirror-editor .prosemirror-image-popup::after {
    display: none;
  }
  
  .prosemirror-editor .prosemirror-anchor-popup::before {
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    left: 50%;
    margin-left: -5px;
    bottom: -6px;
    border: 5px solid transparent;
    border-bottom-width: 0;
    border-top-color: #eaeaea;
  }
  
  .prosemirror-editor .prosemirror-anchor-popup::after {
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    left: 50%;
    margin-left: -5px;
    bottom: -4.5px;
    border: 5px solid transparent;
    border-bottom-width: 0;
    border-top-color: #fff;
  }
  
  .prosemirror-editor .prosemirror-anchor-popup--open-left::before {
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    left: 0%;
    margin-left: -9px;
    bottom: 17px;
    border: 5px solid transparent;
    border-bottom-width: 0;
    border-top-color: #eaeaea;
    transform: rotate(90deg);
  }
  
  .prosemirror-editor .prosemirror-anchor-popup--open-left::after {
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    left: 0%;
    margin-left: -7px;
    bottom: 17px;
    border: 5px solid transparent;
    border-bottom-width: 0;
    border-top-color: #fff;
    transform: rotate(90deg);
  }
  
  .prosemirror-editor .prosemirror-placeholder {
    color: #8d95aa;
    font-size: 12px;
    font-style: italic;
    line-height: normal !important;
  }
  
  .prosemirror-editor .imagePluginRoot .imagePluginOverlay {
    width: unset;
    top: 18px;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid #c4cdd6;
    border-radius: 2px;
  }
  
  .prosemirror-editor .imagePluginRoot .imagePluginOverlay .alignLeftButton {
    order: 0;
  }
  
  .prosemirror-editor .imagePluginRoot .imagePluginOverlay .alignCenterButton {
    order: 1;
    border-left: 1px solid #c4cdd6;
    border-right: 1px solid #c4cdd6;
  }
  
  .prosemirror-editor .imagePluginRoot .imagePluginOverlay .alignRightButton {
    order: 2;
  }
  
  .prosemirror-editor .imagePluginRoot .imagePluginOverlay button {
    font-family: Roboto-Medium, sans-serif;
    text-transform: capitalize;
    /* line-height: 17px; */
    font-size: 13px;
    border: none;
    background-color: #fff;
    color: #363636;
    padding: 5px 10px;
    width: unset;
    cursor: pointer;
  }
  
  .prosemirror-editor .imagePluginRoot .imagePluginOverlay button:hover {
    background-color: #dde3ea;
    border-color: transparent;
    color: #000;
  }
  
  .prosemirror-editor .imagePluginRoot .imageResizeBox {
    box-shadow: none;
    border: 2px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
  }
  
  .prosemirror-editor .imagePluginRoot .imageResizeBox .imageResizeBoxControl.bottomLeft::after,
  .prosemirror-editor .imagePluginRoot .imageResizeBox .imageResizeBoxControl.bottomRight::after {
    background-color: #c5c6c5;
    border-radius: 5px;
  }

  .prosemirror-editor .imagePluginRoot img {
    max-width: 100%;
    width: 100%;
  }
  
  .prosemirror-editor .ProseMirror-table-menu {
    position: relative;
  }
  
  .prosemirror-editor .ProseMirror-table-menu .table-menu-options {
    display: flex;
    width: 132px;
    background: white;
    flex-wrap: wrap;
    padding: 2px;
    position: absolute;
    border: 1px solid transparent;
    box-shadow: #000 0 2px 8px;
  }
  
  .prosemirror-editor .ProseMirror-table-menu .table-menu-options div.table-menu-item {
    background: #1676ee 1a;
    border: 1px solid transparent;
    width: 14px;
    height: 14px;
    margin: 2px;
  }
  
  .prosemirror-editor .ProseMirror-table-menu .table-menu-options .table-menu-highlight {
    background: #5b9ef3 !important;
    border-color: #5b9ef3 !important;
  }
  
  .prosemirror-editor .ProseMirror .tableWrapper {
    overflow-x: auto;
    margin-bottom: 10px;
  }
  
  .prosemirror-editor .ProseMirror table {
    border-collapse: inherit;
    table-layout: fixed;
    width: 100%;
    overflow: hidden;
  }
  
  .prosemirror-editor .ProseMirror td,
  .prosemirror-editor .ProseMirror th {
    vertical-align: top;
    box-sizing: border-box;
    position: relative;
    min-width: 1em;
    border: 1px solid #ddd;
    padding: 3px 5px 2px 5px;
  }
  
  .prosemirror-editor .ProseMirror td p,
  .prosemirror-editor .ProseMirror th p {
    margin: 4px;
  }
  
  .prosemirror-editor .ProseMirror th {
    background-color: #f5f5f5;
  }
  
  .prosemirror-editor .ProseMirror .column-resize-handle {
    position: absolute;
    right: -2px;
    top: 0;
    bottom: 0;
    width: 4px;
    z-index: 20;
    background-color: #adf;
    pointer-events: none;
  }
  
  .prosemirror-editor .ProseMirror.resize-cursor {
    cursor: ew-resize;
    cursor: col-resize;
  }
  
  .prosemirror-editor .ProseMirror .selectedCell:after {
    z-index: 2;
    position: absolute;
    content: "";
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(200, 200, 255, 0.4);
    pointer-events: none;
  }
  
  .prosemirror-editor .suggestion-item-container {
    position: absolute;
    background: #fff;
    border: 1px solid #eaeaea;
    border-radius: 3px;
    z-index: 1;
  }
  
  .prosemirror-editor .suggestion-item-container .suggestion-item-list {
    font-size: 14px;
    max-height: 200px;
    overflow: auto;
    font-family: Roboto-Regular, sans-serif;
  }
  
  .prosemirror-editor .suggestion-item-container .suggestion-item {
    padding: 6px 10px;
  }
  
  .prosemirror-editor .suggestion-item-container .suggestion-item:hover {
    cursor: pointer;
    background: #1676ee 1a;
  }
  
  .prosemirror-editor .suggestion-item-container .suggestion-item .mention-list-username {
    color: #171e48;
    font-size: 13px;
  }
  
  .prosemirror-editor .suggestion-item-container .suggestion-item .mention-list-avatar-image {
    width: 20px !important;
    height: 20px !important;
    border-radius: 50% !important;
    margin-right: 10px !important;
  }
  
  .prosemirror-editor .suggestion-item-container .suggestion-item .mention-list-avatar-generated {
    width: 20px !important;
    height: 20px !important;
    font-family: "Roboto-Regular", sans-serif !important;
    font-size: 10px !important;
    color: #fff !important;
    border-radius: 50% !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    margin-right: 10px !important;
  }
  
  .prosemirror-editor .suggestion-item-container .pm-mention-list-container {
    background: #fff;
    border: 1px solid #eaeaea;
    border-radius: 3px;
    z-index: 1;
  }
  
  .prosemirror-editor .ProseMirror .prosemirror-mention-node {
    padding: 2px 5px;
    background: #f5f5f5 !important;
    border: 1px solid #eaeaea;
    color: #097ac8;
    margin-right: 2px;
  }
  
  .prosemirror-editor .ProseMirror .prosemirror-tag-node {
    padding: 2px 5px;
    background: #f5f5f5 !important;
    border: 1px solid #eaeaea;
    color: #252525;
    margin-right: 2px;
  }
  
  code {
    background-color: whitesmoke;
    color: #b30000;
    font-size: 0.875em;
    font-weight: normal;
    padding: 0.25em 0.5em 0.25em;
  }
  `,
  // DON'T MODIFY THIS - END
  template_meta_data: `
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-UA-Compatible" content="ie=edge">
    <title>PDF Export</title>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap" rel="stylesheet">
  `,
  taskmapper_logo: `
    <svg width="763" height="141" viewBox="0 0 763 141" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.47 140.9C10.7101 140.898 7.10488 139.403 4.44619 136.744C1.7875 134.085 0.292688 130.48 0.290039 126.72V43.1702C0.290039 39.4095 1.78399 35.8027 4.44326 33.1435C7.10253 30.4842 10.7093 28.9902 14.47 28.9902C18.2308 28.9902 21.8375 30.4842 24.4968 33.1435C27.1561 35.8027 28.65 39.4095 28.65 43.1702V126.72C28.6474 130.48 27.1526 134.085 24.4939 136.744C21.8352 139.403 18.23 140.898 14.47 140.9Z" fill="url(#paint0_linear_201_1194)"/>
      <path d="M59.3299 112.28C55.57 112.277 51.9648 110.783 49.3061 108.124C46.6474 105.465 45.1526 101.86 45.1499 98.1001V14.5501C45.1499 12.688 45.5167 10.8441 46.2293 9.12367C46.9419 7.40327 47.9864 5.84008 49.3031 4.52334C50.6199 3.20661 52.1831 2.16212 53.9035 1.4495C55.6239 0.736893 57.4678 0.370117 59.3299 0.370117C61.1921 0.370117 63.036 0.736893 64.7564 1.4495C66.4768 2.16212 68.04 3.20661 69.3567 4.52334C70.6734 5.84008 71.7179 7.40327 72.4305 9.12367C73.1431 10.8441 73.5099 12.688 73.5099 14.5501V98.1001C73.5073 101.86 72.0125 105.465 69.3538 108.124C66.6951 110.783 63.0899 112.277 59.3299 112.28Z" fill="url(#paint1_linear_201_1194)"/>
      <path d="M150.49 38H123V29H187.24V38H159.77V112.31H150.49V38ZM248.63 74.12V112.31H239.71V102.49C235.31 109.89 226.15 113.76 218.06 113.76C205.06 113.76 195.57 106.13 195.57 93.76C195.57 81.39 206.52 72.91 219.73 72.91C226.539 73.0396 233.286 74.2271 239.73 76.43V74.12C239.73 65.64 236.4 55.94 223.08 55.94C216.89 55.94 210.7 58.73 205.08 61.64L201.51 54.24C210.32 49.75 217.69 48.18 223.64 48.18C240.43 48.15 248.63 58.94 248.63 74.09V74.12ZM239.71 92.67V83.09C233.668 81.4036 227.423 80.549 221.15 80.55C211.99 80.55 204.26 85.88 204.26 93.4C204.26 101.16 210.92 105.76 219.61 105.76C227.7 105.73 237.33 101.49 239.71 92.64V92.67ZM257 104.4L261.64 97.73C268.64 102.95 275.64 105.61 282.46 105.61C290.55 105.61 296.02 101.73 296.02 95.79C296.02 89 288.88 86.79 280.55 84.4C265.68 80.03 259.97 75.55 259.97 66.58C259.97 55.18 269.25 48.15 281.51 48.15C289.366 48.3047 297.009 50.7364 303.51 55.15L299.22 62.15C293.04 58.15 286.97 56.21 281.5 56.21C274.6 56.21 268.89 59.36 268.89 65.42C268.89 70.88 273.41 72.58 284.83 76.34C294.7 79.49 304.93 82.88 304.93 94.76C304.93 106.28 295.18 113.67 282.45 113.67C273.166 113.53 264.199 110.264 257 104.4ZM339.56 78.33L365.73 112.33H354.51L333.21 84.57L322.15 95.72V112.33H313.23V27.54H322.15V84.28L355.82 49.6H367.24L339.56 78.33Z" fill="#130C0E"/>
      <path d="M377.1 29H386.38L416.71 87.07L447.05 29H456.33V112.29H447.05V49.36L416.71 107.43L386.38 49.36V112.28H377.1V29ZM517.78 74.1V112.29H508.86V102.47C504.46 109.87 495.3 113.74 487.21 113.74C474.21 113.74 464.72 106.11 464.72 93.74C464.72 81.37 475.67 72.89 488.87 72.89C495.679 73.0197 502.426 74.2072 508.87 76.41V74.1C508.87 65.62 505.54 55.92 492.21 55.92C486.03 55.92 479.84 58.71 474.21 61.62L470.64 54.22C479.45 49.73 486.82 48.16 492.77 48.16C509.57 48.15 517.78 58.94 517.78 74.09V74.1ZM508.86 92.65V83.07C502.818 81.3835 496.573 80.529 490.3 80.53C481.14 80.53 473.41 85.86 473.41 93.38C473.41 101.14 480.07 105.74 488.75 105.74C496.84 105.73 506.48 101.49 508.86 92.64V92.65ZM585.71 80.89C585.71 100.17 573.58 113.74 557.4 113.74C552.81 113.817 548.288 112.623 544.335 110.29C540.382 107.957 537.151 104.576 535 100.52V133.13H526.08V49.6H535V61.36C537.152 57.3063 540.384 53.9269 544.337 51.5955C548.29 49.2641 552.811 48.0716 557.4 48.15C573.58 48.15 585.71 61.73 585.71 80.88V80.89ZM576.31 80.89C576.31 66.46 567.75 56.28 555.73 56.28C543.71 56.28 535 66.45 535 80.88C535 95.31 543.57 105.61 555.7 105.61C567.83 105.61 576.31 95.31 576.31 80.88V80.89ZM653.64 80.89C653.64 100.17 641.5 113.74 625.32 113.74C620.744 113.803 616.239 112.602 612.301 110.269C608.363 107.937 605.145 104.563 603 100.52V133.13H594V49.6H603V61.36C605.149 57.3124 608.374 53.937 612.32 51.606C616.265 49.275 620.778 48.0791 625.36 48.15C641.5 48.15 653.64 61.73 653.64 80.88V80.89ZM644.24 80.89C644.24 66.46 635.67 56.28 623.66 56.28C611.65 56.28 603 66.45 603 80.88C603 95.31 611.56 105.61 623.7 105.61C635.84 105.61 644.24 95.31 644.24 80.88V80.89ZM712.41 98.11L717.88 104.05C712.52 109.99 701.7 113.74 693.13 113.74C676.71 113.74 661.96 100.05 661.96 80.74C661.96 62.07 675.76 48.13 692.3 48.13C710.86 48.13 721.45 62.43 721.45 84.38H671.12C672.43 96.62 680.88 105.59 693.01 105.59C700.27 105.61 708.6 102.34 712.41 98.1V98.11ZM671.24 76.28H712.64C711.45 65.01 704.91 56.28 692.64 56.28C681.71 56.27 672.91 64.15 671.24 76.27V76.28ZM762.58 48.16V56.28C748.66 56.28 738.79 65.01 738.79 77.28V112.28H729.86V49.6H738.79V61.85C742.47 53.48 751.28 48.15 762.58 48.15V48.16Z" fill="url(#paint2_linear_201_1194)"/>
      <defs>
        <linearGradient id="paint0_linear_201_1194" x1="14.47" y1="27.8802" x2="14.47" y2="138.74" gradientUnits="userSpaceOnUse">
          <stop stop-color="#2782C5"/>
          <stop offset="1" stop-color="#39A0A7"/>
        </linearGradient>
        <linearGradient id="paint1_linear_201_1194" x1="59.3299" y1="-0.739882" x2="59.3299" y2="110.12" gradientUnits="userSpaceOnUse">
          <stop stop-color="#3DA89E"/>
          <stop offset="1" stop-color="#45BA86"/>
        </linearGradient>
        <linearGradient id="paint2_linear_201_1194" x1="375.05" y1="81.06" x2="761.63" y2="81.06" gradientUnits="userSpaceOnUse">
          <stop stop-color="#2A81C4"/>
          <stop offset="1" stop-color="#4BBB86"/>
        </linearGradient>
      </defs>
    </svg> 
  `,
  severity_graph_legend: `
    <ul class="fusion-chart__legend">
      <li>
        Severity Level 1: The anomaly is not severe enough to warrant
        immediate action. For example - Dirt, Shadow, Vegetation, Suspected
        Soiling.
      </li>
      <br />
      <li>
        Severity Level 2: These are anomalies whose temperature difference
        &lt; 40°C and not under severity level 1. It is necessary to conduct
        an inspection to identify root cause and rectify the anomaly within
        a short period of time.
      </li>
      <br />
      <li>
        Severity Level 3: These are anomalies with temperature difference
        &gt; 40°C and are safety hazards. These need to be addressed
        immediately.
      </li>
    </ul>
  `,
};

export default { ...print_config };
